export default {
  chartOverlay: {
    opacity: 0,
    width: ({ maxX, minX }) => maxX - minX,
    height: ({ maxY, minY }) => maxY - minY,
    transform: ({ minY, minX }) => `translate(${minX}px,${minY}px)`,
  },
};
